<template>
  <aside>
    <md-sidenav class="md-left" ref="hsSliderMenu">
      <md-toolbar>
        <div class="crm-title">Housing crm</div>
        <div class="user-logo-wrap">
          <div class="user-logo">
            <md-icon class="">
              <i class="pt pt-user"></i>
            </md-icon>
          </div>
          <div class="username-wrap">
            <div class="username">
              Welcome <br /><br />
              {{ userData.firstName }}
            </div>
          </div>
        </div>
      </md-toolbar>
      <div class="navigation-list">
        <md-list>
          <md-list-item @click="goToHome()"
            ><md-icon class=""><i class="pt pt-home"></i></md-icon
            ><span>Home</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('presalesManagerDashboard', { type: 'leads' })"
            v-if="hasAnyRole(['AMOEBA_ADMIN', 'AMOEBA_MANAGER'])"
            ><md-icon class=""><i class="pt pt-copy"></i></md-icon
            ><span>Leads Dashboard</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('presalesAgentDashboard', { type: 'leads' })"
            v-if="userData.userType == 'AGENT'"
            ><md-icon class=""><i class="pt pt-copy"></i></md-icon
            ><span>Leads Dashboard</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('listCampaigns')"
            v-if="hasRole('AMOEBA_ADMIN')"
            ><md-icon class=""><i class="pt pt-travel"></i></md-icon
            ><span>Campaigns</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('completedCampaigns')"
            v-if="hasRole('AMOEBA_ADMIN')"
            ><md-icon class=""><i class="pt pt-book-open"></i></md-icon
            ><span>Completed Campaigns</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('listHandledcases')"
            v-if="hasRole('AMOEBA_ADMIN')"
            ><md-icon class=""><i class="pt pt-meeting-hand"></i></md-icon
            ><span>Handled Cases</span></md-list-item
          >

          <md-list-item @click="goToRoute('insight')"
            ><md-icon class=""><i class="pt pt-floppy-disk"></i></md-icon
            ><span>Insight</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('userManagement')"
            v-if="hasRole('AMOEBA_USER_MANAGEMENT')"
            ><md-icon class=""><i class="pt pt-user"></i></md-icon
            ><span>User Management</span></md-list-item
          >
          <md-list-item
            @click="toggleTmsSubmenu"
            v-if="hasRole('HOUSING_CALLING_ADMIN')"
            ><md-icon class=""><i class="pt pt-landline-phone"></i></md-icon
            ><span>TMS Panel</span></md-list-item
          >

          <div
            v-if="showTmsSubmenu && hasRole('HOUSING_CALLING_ADMIN')"
            class="submenu"
          >
            <md-list-item @click="goToRoute('housingVirtualNumbers')">
              <md-icon class=""><i class="pt pt-call"></i></md-icon>
              <span>Housing Virtual Numbers</span>
            </md-list-item>
            <md-list-item @click="goToRoute('searchCallLogs')">
              <md-icon class=""><i class="pt pt-search"></i></md-icon>
              <span>Search Call Logs</span>
            </md-list-item>
          </div>

          <md-list-item
            @click="goToRoute('pullPriorityPanel')"
            v-if="hasRole('AMOEBA_ADMIN')"
            ><md-icon class=""><i class="pt pt-project"></i></md-icon
            ><span>Pull Priority Panel</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('housingIcrmReport')"
            v-if="hasRole('AMOEBA_ADMIN')"
            ><md-icon class=""><i class="pt pt-uniE900"></i></md-icon
            ><span>Housing Icrm Report</span></md-list-item
          >

          <md-list-item
            @click="goToRoute('leadBucketization')"
            v-if="hasRole('AMOEBA_ADMIN')"
            ><md-icon class=""><i class="pt pt-person-check"></i></md-icon
            ><span>Lead Bucketization</span></md-list-item
          >

          <!-- // Disabling as we do not need this route now -->
          <!-- <md-list-item @click="goToRoute('downloadReport')" v-if="userData.userRole == 'ADMIN' || userData.userRole == 'AMOEBA_ADMIN'"><md-icon class=""><i class="pt pt-check-circle"></i></md-icon><span>Download Report</span></md-list-item> -->

          <md-list-item @click="logout"
            ><md-icon class=""><i class="pt pt-logout"></i></md-icon
            ><span>Logout</span></md-list-item
          >
        </md-list>
      </div>
    </md-sidenav>
  </aside>
</template>

<script type="text/javascript">
import router from "../scripts/router";
import EventBus from "../scripts/event-bus.js";
import UserService from "../scripts/services/userService.js";
import styles from "../styles/scss/hsSliderMenu.scss";

export default {
  data() {
    return {
      userData: {},
      showTmsSubmenu: false,
    };
  },
  mounted() {
    let _this = this;
    _this.initialise();
  },
  methods: {
    initialise: function () {
      let _this = this;
      _this.hsSliderMenu = _this.$refs.hsSliderMenu;
      _this.userData = UserService.getUserData() || {};
      _this.attachEvents();
    },
    attachEvents: function () {
      let _this = this;
      EventBus.$on("toggleSliderMenu", function () {
        _this.hsSliderMenu.toggle();
      });
      EventBus.$on("updateUserData", () => {
        _this.userData = UserService.getUserData();
      });
    },
    closeSliderMenu: function () {
      let _this = this;
      _this.hsSliderMenu.close();
    },
    goToHome: function () {
      let _this = this;
      _this.closeSliderMenu();
      _this.userData = UserService.getUserData();
      router.push({
        name: `${this.userData.defaultScreen}`,
      });
    },
    goToRoute: function (routeName, params) {
      let _this = this;
      _this.closeSliderMenu();
      router.push({
        name: routeName,
        params,
      });
    },
    logout: function () {
      let _this = this;
      _this.closeSliderMenu();
      UserService.logout();
    },
    hasRole(role) {
      return this.userData?.roles?.includes(role);
    },
    hasAnyRole(roles) {
      return roles.some((role) => this.userData?.roles?.includes(role));
    },
    toggleTmsSubmenu: function () {
      this.showTmsSubmenu = !this.showTmsSubmenu;
    },
  },
};
</script>
